import React from 'react';
import EDDialog from '../../../../../BaseComponents/Dialog/EDDialog';
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import EDListItem from '../../../../../BaseComponents/List/Components/EDListItem';
import EDListItemText from '../../../../../BaseComponents/List/Components/EDListItemText';
import EDList from '../../../../../BaseComponents/List/EDList';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import BusinessDataForm, {
  IBusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { AktivitetType__Associations_AktBokRubrik } from './_QueryTypes/AktivitetType';
import EDTooltip from '../../../../../BaseComponents/Tooltip/EDTooltip';
import { useIsSmallScreen } from '../../../../../Hooks/useFullscreenView';
interface IProps {
  formContext: IBusinessDataFormContext<any>;
  deviatingTimeOpen: boolean;
  setDeviatingTimeOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ResursAvvikandeTid: React.FC<React.PropsWithChildren<IProps>> = (
  props: IProps
) => {
  const aktivitetModel: IClientBusinessModel =
    clientAvenyModel.BO.BusinessModels.BOAktivitet;
  const currentDataValues = props.formContext?.formState.currentValues;
  const isSmall = useIsSmallScreen();

  const handleInputFocus = React.useCallback(
    (event: React.FocusEvent<HTMLElement>) => {
      if (event.target instanceof HTMLInputElement) {
        event.target.select();
      }
    },
    []
  );

  if (props.deviatingTimeOpen) {
    return (
      <EDDialog
        open={props.deviatingTimeOpen}
        onClose={() => props.setDeviatingTimeOpen(false)}
        title={'Avvikande tider'}
        subtitle={`Aktivitet: ${
          currentDataValues?.BOKNINGSNUMMER
            ? currentDataValues?.BOKNINGSNUMMER
            : ''
        } ${currentDataValues?.TITEL ? currentDataValues?.TITEL : ''} ${
          currentDataValues?.FRANTID ? currentDataValues?.FRANTID : ''
        }-${currentDataValues?.TILLTID ? currentDataValues?.TILLTID : ''}`}
        fullWidth={true}
        disableContentWrapperMargin={true}
        backdropInvisible={false}
        footerActions={[
          {
            label: 'Klar',
            onClick: () => {
              props.setDeviatingTimeOpen(false);
            },
            buttonProps: {
              disabled: currentDataValues?._Associations?.AktBokRubrik.find(
                (rubrik: { TILLTID: string; FRANTID: string }) => {
                  let rubrikFranTidDate = new Date(
                    currentDataValues.FRANDATUM + ' ' + rubrik.FRANTID
                  );
                  let rubrikTilltidDate = new Date(
                    currentDataValues.TILLDATUM + ' ' + rubrik.TILLTID
                  );
                  let checkTime =
                    !rubrik.FRANTID ||
                    !rubrik.TILLTID ||
                    rubrikFranTidDate >= rubrikTilltidDate;
                  return checkTime;
                }
              ),
              disabledReason:
                currentDataValues?._Associations?.AktBokRubrik.map(
                  (item: { TILLTID: string; FRANTID: string }) => {
                    if (item.TILLTID === '' || item.FRANTID === '') {
                      return 'Fyll i fråntid och tilltid på alla resurser';
                    } else if (item.TILLTID <= item.FRANTID) {
                      return 'Tilltid måste vara senare än fråntid';
                    } else {
                      return undefined;
                    }
                  }
                ),
            },
          },
        ]}
      >
        <EDList style={{ maxHeight: '310px' }}>
          {currentDataValues?._Associations?.AktBokRubrik.map(
            (
              aktBokRubrik: AktivitetType__Associations_AktBokRubrik,
              index: number
            ) => (
              <BusinessDataForm
                isNew={false}
                association={'AktBokRubrik'}
                associatedId={aktBokRubrik.id}
                model={aktivitetModel}
                key={index}
              >
                <EDListItem
                  divider={
                    index <
                    currentDataValues?._Associations?.AktBokRubrik.length - 1
                  }
                >
                  <EDListItemText
                    style={{ width: '40%' }}
                    primary={
                      <EDTypography color="textPrimary">
                        {aktBokRubrik.RESURS_NAMN}
                      </EDTypography>
                    }
                    secondary={
                      <EDTypography
                        color="textPrimary"
                        style={{ fontSize: 10 }}
                      >
                        {aktBokRubrik?._Associations?.Resurs?._Associations
                          ?.ResRestyp?.BO_RESURSTYP_NAMN !== null
                          ? aktBokRubrik?._Associations?.Resurs?._Associations
                              ?.ResRestyp?.BO_RESURSTYP_NAMN
                          : ''}
                      </EDTypography>
                    }
                  />
                  {!(
                    currentDataValues.FRANTID === aktBokRubrik.FRANTID &&
                    currentDataValues.TILLTID === aktBokRubrik.TILLTID
                  ) && (
                    <EDTooltip title="Resursen är bokad på en avvikande tid">
                      <EDBox>
                        <EDIcon
                          marginTop={1.6}
                          marginRight={1}
                          marginLeft={1}
                          iconType="deviating_time"
                        />
                      </EDBox>
                    </EDTooltip>
                  )}
                  <EDBox sx={{ width: '40%' }}>
                    <Attribut
                      name="FRANTID"
                      grayTextColor={
                        currentDataValues.FRANTID === aktBokRubrik.FRANTID
                      }
                      paddingRight={isSmall ? 0 : 1}
                      hideClearIcon={
                        currentDataValues.FRANTID === aktBokRubrik.FRANTID
                      }
                      defaultClearValue={currentDataValues.FRANTID}
                      tooltipRensa="Rensa avvikande fråntid"
                      onFocus={handleInputFocus}
                    />
                    <Attribut
                      name="TILLTID"
                      grayTextColor={
                        currentDataValues.TILLTID === aktBokRubrik.TILLTID
                      }
                      hideClearIcon={
                        currentDataValues.TILLTID === aktBokRubrik.TILLTID
                      }
                      defaultClearValue={currentDataValues.TILLTID}
                      tooltipRensa="Rensa avvikande tilltid"
                      onFocus={handleInputFocus}
                    />
                  </EDBox>
                </EDListItem>
              </BusinessDataForm>
            )
          )}
        </EDList>
      </EDDialog>
    );
  } else return <></>;
};
